export enum InvoiceFundingStatus {
    /** 0 [(lsq.common.annotations.enum_display_name) */
    UNFUNDED = 'UNFUNDED',
    /** 1 [(lsq.common.annotations.enum_display_name) */
    ELIGIBLE = 'ELIGIBLE',
    /** 2 [(lsq.common.annotations.enum_display_name) */
    SCHEDULED = 'SCHEDULED',
    /** 3 [(lsq.common.annotations.enum_display_name) */
    PENDING = 'PENDING',
    /** 4 [(lsq.common.annotations.enum_display_name) */
    FUNDED = 'FUNDED',
    /** 5 [(lsq.common.annotations.enum_display_name) */
    EARLY_PAID = 'EARLY_PAID',
    /** 6 [(lsq.common.annotations.enum_display_name) */
    CLOSED = 'CLOSED',
    /** 7 [(lsq.common.annotations.enum_display_name) */
    WILL_NOT_FUND = 'WILL_NOT_FUND',
    /** 8 [(lsq.common.annotations.enum_display_name) */
    INELIGIBLE = 'INELIGIBLE',
    /** 9 [(lsq.common.annotations.enum_display_name) */
    UNKNOWN_STATUS = 'UNKNOWN_STATUS',
    /** 10 [(lsq.common.annotations.enum_display_name) */
    SENT = 'SENT',
    /** 11 [(lsq.common.annotations.enum_display_name) */
    FUNDING_REJECTED = 'FUNDING_REJECTED',
    /** 12 [(lsq.common.annotations.enum_display_name) */
    EARLY_PAID_CLOSED = 'EARLY_PAID_CLOSED',
    /** 13 [(lsq.common.annotations.enum_display_name) */
    PAID = 'PAID',
    /** 14 [(lsq.common.annotations.enum_display_name) */
    REVOKED = 'REVOKED'
}
